export const ABOUT_SERVICE = [
  {
    id: 1,
    title: 'О сервисе',
    imageClass: 'backpack',
    description: [
      {
        text: 'Незаменимый помощник для собственника в долгосрочной аренде.',
      },
      {
        text: 'Мы займёмся каждым этапом сделки, чтобы сдать квартиру без риска и в кратчайшие сроки — от вас потребуются лишь ключи.',
      },
      {
        text: 'Не нужно тратить время даже на дорогу: мы проведём показы дистанционно, подберём и согласуем надёжных кандидатов, а договор подпишем онлайн.',
      },
    ],
  },
  {
    id: 2,
    title: 'ПИК-Аренда',
    imageClass: 'like',
    description: [
      {
        text: 'Первый онлайн-сервис долгосрочной аренды в России',
        imageClass: 'big-star',
      },
      {
        text: 'В среднем находим арендатора за 8–10 дней',
        imageClass: 'calendar-star',
      },
      {
        text: '7 млн показов — месячный охват объявлений ПИК-Аренда на Циан',
        imageClass: 'approve-circle',
      },
    ],
  },
  {
    id: 3,
    title: 'ЦИАН',
    imageClass: 'house',
    notice: true,
    description: [
      {
        text: 'Циан — лидер рынка среди сервисов по недвижимости',
        imageClass: 'circle-star',
      },
      {
        text: '8 из 10 человек в 2024 году выберут и купят квартиру на Циан',
        imageClass: 'form',
      },
      {
        text: 'На Циан самая большая база актуальных объявлений',
        imageClass: 'up-arrow',
      },
    ],
  },
];
